const l = {
  name: "Pudding",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,4c0,0.7-0.2,1.4-0.5,2h5.2c2.4,0,4.5,1.7,4.9,4.1l0,0L36.8,28H40v2h-3.3l-2,6H5.3l-2-6H0v-2h3.2l3.3-17.9
			l0,0C6.9,7.7,8.9,6,11.3,6h5.2C16.2,5.4,16,4.7,16,4c0-2.2,1.8-4,4-4C22.2,0,24,1.8,24,4z M18,4c0,1.1,0.9,2,2,2s2-0.9,2-2
			s-0.9-2-2-2S18,2.9,18,4z M23.6,8c0.4,0.6,0.6,1.2,0.6,1.9L25.9,28h4.4L28,10.6C27.8,9.1,26.5,8,25,8H23.6z M16.4,8H15
			c-1.5,0-2.8,1.1-3,2.6L9.7,28h4.4l1.6-18.1l0,0C15.8,9.2,16,8.6,16.4,8z M16.1,28h7.8l-1.6-17.9l0,0C22.2,8.9,21.2,8,20,8
			c-1.2,0-2.2,0.9-2.3,2.1l0,0L16.1,28z M30,10.3L32.4,28h2.4l-3.2-17.5l0,0C31.4,9.2,30.3,8.2,29,8C29.5,8.7,29.8,9.5,30,10.3z
			 M10,10.3C10.2,9.5,10.5,8.7,11,8c-1.3,0.2-2.4,1.1-2.6,2.4l0,0L5.2,28h2.4L10,10.3z M5.4,30l1.3,4h26.6l1.3-4H5.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Pudding
};
